import React from 'react';
import IconName from "../../../../svgLogo/SvgLogo";

const OrderBundleInfo = () => {
    return (
        <div className="order-bundle-info-wrapper xmt-8">
            <div className="title-bundle-info d-flex justify-content-between align-items-center xpx-4 xpy-3 xpx-lg-6 xpy-lg-4">
                <span className="order persian-number">مرسوله ۱ از ۱</span>
                <span className="post d-none d-lg-inline-block"><IconName name="moped" className="icon"/> ارسال با پیک موتوری (تبریز)</span>
                <span className="time d-none d-lg-inline-block persian-number">زمان ارسال : یکشنبه 16 خرداد</span>
                <span className="show-factor">مشاهده فاکتور</span>
            </div>
            <div className="send-info-responsive d-block d-lg-none xpx-4 xpy-3">
                <span className="post"> ارسال با پیک موتوری (تبریز)</span>
                <span className="time d-block xmt-4 persian-number">زمان ارسال : یکشنبه 16 خرداد</span>
            </div>
            <div className="follow-order-box d-block d-lg-flex justify-content-between align-items-center xpx-4 xpy-3 xpx-lg-6 xpy-lg-4">
                <span className="description d-block d-lg-inline-block">لطفا در صورت دریافت کامل مرسوله، کد روبرو را به مأمور ارسال تحویل دهید: شناسه تحویل مرسوله: 87899</span>
                <a href="#" className="follow-order d-block d-lg-inline-block xmt-3 xmt-lg-0">پیگیری مرسوله</a>
            </div>
            <div className="order-product">
                <div className="list-product position-relative">
                    <div className="price-box position-absolute">
                        <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                    </div>
                    <div className="title-product-responsive d-block d-md-none">
                        <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                    </div>
                    <div className="content-cart d-flex align-items-center">
                        <div className="img-product">
                            <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                        </div>
                        <div className="info-product">
                            <div className="title-product d-none d-md-block">
                                <h2 className="big-title persian-number d-none d-lg-block">گوشی شیائومی می نوت 9 پرو
                                    دوسیم
                                    کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ
                                    رم</h2>
                                <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                            </div>
                            <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                                <span className="text-color">مشکی</span>
                            </div>
                            <div className="seller-info d-none d-lg-flex align-items-center">
                                <div className="name-seller">
                                    <IconName name="add_business" className="icon"/>
                                    <span className="text">کامپیوتر زرد آذربایجان</span>
                                </div>
                            </div>
                            <div className="register-product d-none d-lg-block">
                                <IconName name="verified_user" className="icon"/>
                                <span className="text">  تضمین ثبت در شبکه رجیستری بدون هزینه اضافی (رجیستر شده)</span>
                            </div>

                            <div className="text-info-product-responsive d-block d-lg-none">
                                <div className="warranty-product">
                                    <IconName name="verified_user" className="icon"/>
                                    <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                                </div>
                                <div className="seller-name-responsive">
                                    <IconName name="add_business" className="icon"/>
                                    <span className="text">کامپیوتر زرد </span>
                                </div>
                                <div className="send-product">
                                    <IconName name="date" className="icon"/>
                                    <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="list-product position-relative">
                    <div className="price-box position-absolute">
                        <span className="price persian-number">۲،۷۶۰،۰۰۰ ت</span>
                    </div>
                    <div className="title-product-responsive d-block d-md-none">
                        <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                    </div>
                    <div className="content-cart d-flex align-items-center">
                        <div className="img-product">
                            <img src="./assets/sample-image/1420-w320h320.png" alt="img"/>
                        </div>
                        <div className="info-product">
                            <div className="title-product d-none d-md-block">
                                <h2 className="big-title persian-number d-none d-lg-block">گوشی شیائومی می نوت 9 پرو
                                    دوسیم
                                    کارت ظرفیت ۶۴ گیگابایت - ۶ گیگ
                                    رم</h2>
                                <h3 className="small-title">Xiaomi Redmi Note 9 Pro Global Dual SIM 64GB- 6GB RAM</h3>
                            </div>
                            <div className="color-product d-flex align-items-center">
                            <span className="color black">
                            </span>
                                <span className="text-color">مشکی</span>
                            </div>
                            <div className="seller-info d-none d-lg-flex align-items-center">
                                <div className="name-seller">
                                    <IconName name="add_business" className="icon"/>
                                    <span className="text">کامپیوتر زرد آذربایجان</span>
                                </div>
                            </div>
                            <div className="register-product d-none d-lg-block">
                                <IconName name="verified_user" className="icon"/>
                                <span className="text">  تضمین ثبت در شبکه رجیستری بدون هزینه اضافی (رجیستر شده)</span>
                            </div>

                            <div className="text-info-product-responsive d-block d-lg-none">
                                <div className="warranty-product">
                                    <IconName name="verified_user" className="icon"/>
                                    <span className="text">گارانتی ۱۸ ماهه‌ی سایمان</span>
                                </div>
                                <div className="seller-name-responsive">
                                    <IconName name="add_business" className="icon"/>
                                    <span className="text">کامپیوتر زرد </span>
                                </div>
                                <div className="send-product">
                                    <IconName name="date" className="icon"/>
                                    <span className="text">ارسال کالا از ۱ روز کاری آینده</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="order-price xp-4 xp-lg-6">
                <div className="row">
                    <div className="col-lg-6">
                        <div className="total-price d-flex justify-content-between align-items-center">
                            <span className="text">جمع کل</span>
                            <span className="number persian-number">57,268,000</span>
                        </div>
                    </div>
                    <div className="col-lg-6">
                        <div className="send-price d-flex justify-content-between align-items-center xmt-4 xmt-lg-0">
                            <span className="text">هزینه ارسال</span>
                            <span className="number persian-number">پس کرایه</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
};

export default OrderBundleInfo;
